export default "__VITE_ASSET__dF8TzYVE__"